/**
 * Copyable-invitation-text helper shared by `UsersPage.tsx` (the standalone
 * `/admin/users` page). The bucket-id module/role preset tables that used to
 * live here (`MODULE_PERMISSIONS`/`ROLE_PRESETS`) were removed — `UsersPage`
 * now shares the real `permissions/catalog`-backed access preset flow
 * `routes/setup/TeamStep.tsx` already used (BUG-01/BUG-04/BUG-21: the bucket
 * ids never mapped to real permission keys, and the resulting `roleId`
 * guesswork silently escalated every invite to `tenant-admin`).
 */
export interface InviteModalData {
  readonly firstName: string;
  readonly lastName: string;
  readonly mobile: string;
  readonly jobTitle: string;
  readonly permissions: readonly string[];
  readonly loginUrl: string;
}

export function generateInvitationText(data: InviteModalData): string {
  const permList = data.permissions.join('، ');
  return `${data.firstName} ${data.lastName} عزیز 🌟
برای شما دسترسی پنل ساختار فعال شد. ✅

سمت سازمانی: ${data.jobTitle}
بخش‌های فعال: ${permList}

لینک ورود:
${data.loginUrl}

نام کاربری:
${data.mobile}

رمز موقت:
از طریق پیامک برای شما ارسال شد. پس از اولین ورود، رمز جدید خود را ثبت کنید. 🔑

ساختار سیستم`;
}
